/**
 * Theme Requirements Aggregation for Repli Training
 * 
 * Extends the base roxanne theme requirements with Repli Training specific
 * component requirements.
 */

import type { ComponentRequirements } from '@vibesites/tokens';
import { componentRequirements as baseRequirements } from '@vibesites/theme-roxanne/requirements';

/**
 * Repli Training component requirement overrides.
 * Add requirements for any override components here.
 */
const replitrainingOverrides: Record<string, ComponentRequirements> = {
  // Example:
  // Footer: FooterRequirements,
};

/**
 * All component requirements for the Repli Training theme.
 * Inherits from roxanne theme and overrides with Repli Training components.
 */
export const componentRequirements: Record<string, ComponentRequirements> = {
  ...baseRequirements,
  ...replitrainingOverrides,
};

/**
 * Get requirements for a specific component.
 */
export function getComponentRequirements(componentName: string): ComponentRequirements | undefined {
  return componentRequirements[componentName];
}

/**
 * Get all component names that have requirements defined.
 */
export function getRegisteredComponentNames(): string[] {
  return Object.keys(componentRequirements);
}
